import { render, staticRenderFns } from "./titleBlock_computer.vue?vue&type=template&id=459876ae&scoped=true"
import script from "./titleBlock_computer.vue?vue&type=script&lang=js"
export * from "./titleBlock_computer.vue?vue&type=script&lang=js"
import style1 from "./titleBlock_computer.vue?vue&type=style&index=1&id=459876ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459876ae",
  null
  
)

export default component.exports